import styled, {css} from 'styled-components'

export const StyledHomeCard = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;
        align-items: flex-start;
        justify-content: space-between;
    `
)
